import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '16px 0'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 2fr',
    gap: 24,
    alignItems: 'center'
  },
  title: { fontWeight: 500, fontSize: 18, color: theme.palette.text.primary },
  subTitle: { fontWeight: 500, fontSize: 14 },
  roleSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  searchInput: {
    marginBottom: 12
  },
  clearIconButton: {
    position: 'absolute',
    top: '5%',
    right: 32,
    cursor: 'pointer'
  },
  clearIcon: {
    fontSize: 16
  },
  entitySelectorContainer: {
    width: '46%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  resourceTypeSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
